import { LoadingOutlined } from "@ant-design/icons";
import { Progress, Spin } from "antd";
import React from "react";
import "./index.less";

type props = {
  refProp?: any;
  progress?: boolean;
  progressValue?: number;
  message?: string;
  size?: number;
};

const SpinnerComponent: React.FC<props> = ({ refProp, progress, progressValue, message = "", size = 60 }) => {
  return (
    <div ref={refProp} style={{ display: "flex", flexDirection: "column" }}>
      <Spin
        tip={message}
        indicator={
          progress ? (
            <Progress percent={progressValue} type="circle" style={{ fontSize: size, color: "#fff" }} />
          ) : (
            <LoadingOutlined style={{ fontSize: size, color: "#fff" }} spin />
          )
        }
      />
    </div>
  );
};

export default SpinnerComponent;
